export default "__VITE_ASSET__CsfpVZnE__"